import _defineProperty from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _inherits from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _wrapRegExp(re, groups) { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, groups); }; var _RegExp = _wrapNativeSuper(RegExp); var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, groups) { var _this = _RegExp.call(this, re); _groups.set(_this, groups); return _this; } _inherits(BabelRegExp, _RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = []; args.push.apply(args, arguments); if (typeof args[args.length - 1] !== "object") { args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

import { ExpiredTokenCode } from '@tradingblock/types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import _ from 'lodash';
import { toRawOccSymbol, isOCCSymbol } from '..';
export var WebsocketFeedParser =
/*#__PURE__*/
function () {
  function WebsocketFeedParser(value) {
    var _this = this;

    _classCallCheck(this, WebsocketFeedParser);

    this.str = function (ind) {
      return _this.values[ind];
    };

    this.int = function (ind) {
      return parseInt(_this.str(ind));
    };

    this.float = function (ind) {
      return parseFloat(_this.str(ind));
    };

    this.date = function (ind) {
      return dayjs(_this.str(ind));
    };

    this.success = function (ind) {
      return _this.int(ind) === 0 ? true : false;
    };

    this.getMessageType = function (typeVal) {
      var typeValInt = _this.int(typeVal);

      switch (typeValInt) {
        case 100:
        case 0:
          return 'HeartBeat';

        case 1:
          return 'Quote';

        case 2:
          return 'Spread';

        case 3:
          return 'OrderUpdate';

        case 4:
          return 'Settlement';

        case 90:
          return 'ExpiredToken';

        default:
          return undefined;
      }
    };

    this.metadata = function () {
      return {
        success: _this.success(0),
        type: _this.getMessageType(1),
        raw: _this.raw
      };
    };

    this.parseExpiredTokenMessage = function () {
      var metadata = _this.metadata();

      var Code = _this.int(2) === 10 ? ExpiredTokenCode.DuplicateLogin : ExpiredTokenCode.Unknown;
      return Object.assign({}, metadata, {
        Code: Code,
        Reason: _this.str(3),
        isValid: true
      });
    };

    this.parseQuote = function () {
      var metadata = _this.metadata();

      var _QuoteTime = {
        QuoteTime: _this.str(2)
      },
          QuoteTime = _QuoteTime.QuoteTime;

      var symbol = _this.str(3);

      var Symbol = isOCCSymbol(symbol) ? toRawOccSymbol(symbol) : symbol;
      return Object.assign({}, metadata, {
        QuoteTime: QuoteTime,
        Symbol: Symbol,
        LastTradePrice: _this.float(4),
        BidPrice: _this.float(5),
        AskPrice: _this.float(6),
        NetChange: _this.float(7),
        High: _this.float(8),
        Low: _this.float(9),
        Volume: _this.float(10),
        ChangePercentage: _this.float(11),
        BidSize: _this.float(12),
        AskSize: _this.float(13),
        isValid: dayjs(QuoteTime, 'MM/DD/YYYY HH:mm:ss').isValid() && dayjs(QuoteTime, 'MM/DD/YYYY HH:mm:ss').year() >= dayjs().year()
      });
    };

    this.parseOrderUpdate = function () {
      var metadata = _this.metadata();

      return Object.assign({}, metadata, {
        AccountId: _this.int(2),
        OrderId: _this.int(3),
        OrderTime: _this.date(4).toDate(),
        Symbol: _this.str(5),
        OrderQuantity: _this.float(6),
        FilledQuantity: _this.float(7),
        OrderPrice: _this.float(8),
        OrderAction: _this.str(9),
        OrderStatus: _this.int(10),
        Expiration: _this.date(11).toDate(),
        CallPut: _this.str(12),
        Strike: _this.float(13),
        isValid: true
      });
    };

    this.parseSettlement = function () {
      var metadata = _this.metadata();

      return Object.assign({}, metadata, {
        CloseDate: _this.str(2),
        Symbol: _this.str(3),
        ClosePrice: _this.float(4),
        ClosePriceTMinus2: _this.float(5),
        IsSettlementSet: true,
        isValid: true
      });
    };

    this.parseHeartbeat = function () {
      var metadata = _this.metadata();

      return Object.assign({}, metadata, {
        isValid: true
      });
    };

    this.parseMap = {
      Quote: this.parseQuote,
      HeartBeat: this.parseHeartbeat,
      OrderUpdate: this.parseOrderUpdate,
      ExpiredToken: this.parseExpiredTokenMessage,
      Spread: this.parseUnknown,
      Settlement: this.parseSettlement
    };

    this.parse = function () {
      var parser = _this.parseMap;

      var metadata = _this.metadata();

      if (parser && metadata && metadata.type && parser[metadata.type]) {
        return parser[metadata.type]();
      }

      return undefined;
    };

    this.values = value.split('|').reduce(function (acc, vv) {
      var matchVal = vv.match(_wrapRegExp(/(\d+)=(.*)/, {
        fieldkey: 1,
        fieldvalue: 2
      }));

      if (_.isNil(matchVal)) {
        return acc;
      } // vv.replace(/(\d+)=/, '')


      var _matchVal$groups = matchVal.groups,
          fieldkey = _matchVal$groups.fieldkey,
          fieldvalue = _matchVal$groups.fieldvalue;

      var fKey = _.parseInt(fieldkey);

      if (_.isNil(fKey) || _.isNaN(fKey)) {
        return acc;
      }

      return Object.assign({}, acc, _defineProperty({}, fKey, fieldvalue));
    }, {});
    this.raw = value; // if (vals.length < 12) {
    // console.warn('quote string from feed has less fields than expected', value);
    // }
  }

  _createClass(WebsocketFeedParser, [{
    key: "parseUnknown",
    value: function parseUnknown() {
      var metadata = this.metadata();
      return Object.assign({}, metadata, {
        isValid: true
      });
    }
  }]);

  return WebsocketFeedParser;
}();